<div class="pontuacao">
  @if (!pontuado) {
    <div class="nao-pontuado">
      @if (idPrecisao == 'NP') {
        <span>Não Pontuado</span>
      }
      @if (idPrecisao == 'NA') {
        <span>Não Aplicável</span>
      }
    </div>
  }

  @if (pontuado) {
    <div class="pontuado">
      @if (vlPontuacao != null) {
        <div>
          <div>
            <span>
              {{ vlPontuacao | number: '1.' + decimais }}
            </span>
            @if (inconsistente) {
              <span pTooltip="Inconsistente" tooltipPosition="bottom" class="inconsistente"> INC </span>
            }
            @if (tendencia && vlPontuacao !== 0) {
              <span [title]="tendencia?.title" [class]="tendencia?.icon" [style.color]="tendencia?.color"> </span>
              @if (pcDeltaPrevia != null) {
                <span class="delta"> {{ pcDeltaPrevia | number: '1.1-2' }} %</span>
              }
            }
          </div>
          <div [class]="vlPontuacao | pontuacao"></div>
        </div>
      }
      <!-- Regra do Simulador -->
      @if (vlPontuacao == null) {
        <div>
          @if (!vazio) {
            <span>{{ idPrecisao }}</span>
          }
        </div>
      }
    </div>
  }
</div>
